import * as React from "react";
import LoginErrMsg from "../generic/loginErrMsg";
import "../../../assets/scss/Login/login/forms/passwordForm.scss";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import { countDown } from "../../utils/countDown";
import YobInputField from "../generic/yobInputField";
import { Link } from "react-router-dom";

export interface IOtpFormProps {
  errorMsg?: string;
  onSubmit: (yob: string) => void;
  onClose?: () => void;
  onRemoveError: () => void; // removes the errorMsg
  autoFocus?: boolean;
  onTimerClose: () => void;
  disableForm?: boolean;
  redirect?: string;
  redirectText?: string;
  otpTitle?: string;
  containerClass?: string;
  showResend?: boolean;
  onChangeFunc?: (otp: string) => void;
  ResendFunction?:() => void;
}

const OtpForm: React.FC<IOtpFormProps> = (props) => {
  const [otp, setOtp] = React.useState("");
  const [timer, setTimer] = React.useState({
    min: 4,
    sec: 59,
  });

  function onChangeHandler(value: string) {
    setOtp(value);
    props.onChangeFunc && props.onChangeFunc(value);
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }

  function handleResendOtp(){
    props.onRemoveError();
    props.ResendFunction && props.ResendFunction();
    setTimer({ min: 4, sec: 59, })
  }

  function handleSubmit() {
    props.onSubmit(otp);
  }

  React.useEffect(() => {
    if (otp.length === 4) {
      handleSubmit();
    }
  }, [otp]);

  React.useEffect(() => {
    if (props.errorMsg) {
      setOtp("");
    }
  }, [props.errorMsg]);

  React.useEffect(() => {
    let intervalId = setInterval(function () {
      countDown(timer.min, timer.sec, setTimer);
    }, 1000);

    if (timer.min === 0 && timer.sec === 0) {
      clearInterval(intervalId);
      props.onTimerClose();
    }
    return () => {
      clearInterval(intervalId);
    };
  });

  return (
    <div className={"login_form pw_form " + (props.containerClass || "")}>
      <form autoComplete="off" className="mg-b30">
        <label className="inp_lbl mg-b15 pd-b30 ib text-center">{props.otpTitle ? props.otpTitle : 'Enter OTP'}</label>

        <YobInputField
          placeholder=""
          onChange={onChangeHandler}
          type={"text"}
          defaultValue={otp}
          id={"otp-"}
          autoFocus={props.autoFocus==false ? props.autoFocus : true}
          disabled={props.disableForm}
        />
        <p className="help_text mg-b40"></p>

        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">
            {props.errorMsg}
            {props.redirect && (
              <div>
                <Link to={props.redirect}>{props.redirectText}</Link>
              </div>
            )}
          </LoginErrMsg>
        )}
        { props.showResend && timer.min === 0 && timer.sec === 0 && (
          <div className="timer">
            <a onClick={() => handleResendOtp() } className="font-14">Resend OTP</a>
          </div>
        )}
        {!props.disableForm && (timer.min !== 0 || timer.sec !== 0 ) && (
          <div className="timer mg-b40">
            <span>0{timer.min}</span>
            <span>:</span>
            <span>{timer.sec > 9 ? timer.sec : "0" + timer.sec}</span>
          </div>
        )}
      </form>
    </div>
  );
};

export default OtpForm;
